import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css', '../../../assets/css/admin-styles.css', '../../../assets/css/developer-admin.css']
})
export class AdminLayoutComponent implements OnInit {


  constructor(
    public location: Location,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.appendStyle('admin-css', 'assets/css/admin-styles.css');
    this.appendStyle('developer-admin-css', 'assets/css/developer-admin.css');
  }

  ngOnDestroy(): void {
    this.removeStyle('admin-css');
    this.removeStyle('developer-admin-css');
  }

  // Utility methods to keep code clean
  private appendStyle(id: string, href: string): void {
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.id = id;
      document.head.appendChild(link);
    }
  }

  private removeStyle(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      el.remove();
    }
  }

}
